import { render, staticRenderFns } from "./UserListPager.vue?vue&type=template&id=1864be1e&functional=true&"
import script from "./UserListPager.vue?vue&type=script&lang=ts&"
export * from "./UserListPager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports